<template>
    <div id="login_btn" v-if="user.login">
      <span @click="dialogVisible = true"><i class="fas fa-info-circle fa-fw"></i>はじめに</span>
      <i class="fa fa-user fa-fw"></i>{{ user.name }}さん
      <span @click="mypage"><i class="fas fa-address-card fa-fw" title="マイページ"></i></span>
      <span v-if="!user.validmail" @click="goUsrInfo"><i class="fas fa-exclamation-triangle" title="メールアドレス未確認" style="color:yellow"></i></span>
      <span v-if="user.admin_flg" @click="goKanri">[管理画面]</span>
      <span @click="logout"><i class="fas fa-sign-out-alt fa-fw" title="サインアウト"></i></span>
      </div>
      <div id="login_btn" v-if="!user.login">
      <span @click="dialogVisible = true"><i class="fas fa-info-circle fa-fw"></i>はじめに</span>
      <router-link to="/regist"><i class="fas fa-address-card fa-fw"></i>ユーザ登録</router-link>
      <router-link to="/login"><i class="fa fa-user fa-fw"></i>ログイン</router-link>
    </div>
    <el-dialog
      title="はじめにお読みください"
      v-model="dialogVisible"
      width="80%"
      center>
      <ul>
        <li>見積保存・発注するにはユーザ登録が必要です。</li>
        <li>配布期間の受注済数により発注可能数は変動します。「選択エリアパネル」の「エリア発注可能数」をご確認ください。</li>
        <li>地図をダブルクリックまたはロングタップすると、「選択条件指定」ダイアログが表示されます。半径または枚数を指定いただくことで指定地点を起点に配布エリアが選択されます。</li>
        <li>見積結果合計部数の端数は、選択エリアから1エリアを選んで配布数を減らすことで調整できます。「選択エリアパネル」で調整したい選択エリア行右端の鉛筆アイコン（配布数調整）をクリックして表示される「配布数調整」ダイアログの調整後部数を変更して「OK」ボタンをクリックしてください。調整後の配布数は太字で表示されます。</li>
        <li>WEBからのお申し込みは、納品締切日の正午まで可能です。</li>
        <li>クレジットカード支払いは現在準備中です。入金確認の余裕を見て発注をお願いします。</li>
        <li>配布物は、納品期限までに以下の場所に納品してください。<br>
          ポストエクスプレス栃木支社 by 株式会社アシストパル<br>
          〒321-0204<br>
          栃木県下都賀郡壬生町緑町2-6-2<br>
          不在の場合の連絡先：090-3501-5822（本橋／モトハシ）<br>
          ※配布物を直接お持ち込みいただく場合は、お越しいただく前に以下にご連絡をお願いします。<br>
          090-3501-5822（本橋）または、050-3851-1100
        </li>
      </ul>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">Close</el-button>
        </span>
      </template>
    </el-dialog>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { clsUser } from '@/types/clsUser';
import { app } from '../main';
import { version } from '../../package.json';

export default defineComponent({
  props: ['user'],
  emits: ['login'],
  setup(_, context) {
    const router = useRouter()
    const route = useRoute()
    const dialogVisible = ref(false)
    const logout = () => {
      const api_path = app.config.globalProperties.api_path
      fetch(api_path + 'ajax/logout.php', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => response.json())
      .then(json => {
        console.log(json);
        context.emit('login', new clsUser())
        if(route.path !== '/') {
          router.push({ path: '/' })
        }
      })
      .catch(error => console.error(error))
    }
    const mypage = () => {
      router.push({ path: '/mypage' })
    }
    const goUsrInfo = () => {
      router.push({ path: '/usrinfo' })
    }
    const goKanri = () => {
      window.location.href = '/tochigi/kanri/'
    }
    onMounted(() => {
      const api_path = app.config.globalProperties.api_path
      fetch(api_path + 'ajax/resession.php', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => response.json())
      .then(json => {
        // バージョンアップ処理
        let reloadCnt = 0
        if(sessionStorage.getItem('reloadCnt')) {
          reloadCnt = Number(sessionStorage.getItem('reloadCnt'))
        }
        if(reloadCnt > 0) {
          if(json.version == version) {
            app.config.globalProperties.$notify({
              title: 'UPDATE',
              message: `Version ${version}に更新されました。`,
              type: 'success'
            })
          }else {
            app.config.globalProperties.$notify({
              title: 'UPDATE',
              message: `Version ${json.version}に更新できませんでした。`,
              type: 'warning'
            })
          }
          sessionStorage.removeItem('reloadCnt')
        }else {
          if(json.version != version) {
            sessionStorage.setItem('reloadCnt', (++reloadCnt).toString())
            location.reload()
          }
        }
        // 自動ログイン処理
        if(json['result'] == 'failure') {
          if(json['error_cd'] == 0) {
            console.log(json.error)
            return
          }else {
            throw new Error(json.error)
          }
        }
        const loginUser = new clsUser()
        loginUser.login = true
        loginUser.name = json['user_name']
        loginUser.email = json['address']
        loginUser.csrf = json['csrf']
        loginUser.admin_flg = json['admin_flg'] == '1'
        loginUser.validmail = json['validmail'] == '1'
        context.emit('login', loginUser)
        if(route.path == '/login') {
          router.push({ path: '/mypage' })
        }
      })
      .catch(error => console.error(error))
    })

    return {
      dialogVisible,
      logout,
      mypage,
      goUsrInfo,
      goKanri
    }
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#login_btn {
  padding: 7px 10px 0;
}
#login_btn a {
  margin-left: 1em;
}
#login_btn span {
  cursor: pointer;
  margin-right: 10px;
}
</style>